import React from "react";
import BusinessTabs from "./BusinessTabs";
import Section from "../../layouts/Section";
import FeatureSnowflakeHead from "./FeatureSnowflakeHead";

const ProductLists = [
    {
        title: "통합 시스템 데이터로 IT 운영 효율화",
        description: "Snowflake, https://www.snowflake.com/",
        description_01:
            "Snowflake 커넥터를 활용하여 기업의 분산된 데이터를 하나의 플랫폼으로 통합합니다. 이로써 운영 시스템 간 연결성을 강화하고, 실시간 데이터 기반의 의사결정을 가능하게 하여 IT 운영의 효율성을 극대할 수 있습니다.",
        // description_02: "ServiceNow에서 Snowflake로 데이터를 자동으로 수집합니다. 이 커넥터는 과거 데이터의 초기 로드와 증분 업데이트를 모두 지원합니다.",
        imgSrcPd: "/img/salesforce/snowflake-product-01.png"
    },
    {
        title: "ERP 데이터 통합",
        description: "Snowflake, https://www.snowflake.com/",
        description_01:
            "Snowflake의 AI 데이터 클라우드를 기반으로 ERP 데이터를 통합합니다. 이로써 비용 절감은 물론, 비즈니스 프로세스 최적화와 부서 간 협업 효율을 향상시키며, 하나의 데이터 뷰로 조직 전체를 확인할 수 있습니다.",
        // description_02: "Snowflake의 분석 기능으로 SAP 데이터에서 더 많은 가치 창출고객이 모든 데이터를 분석할 수 있는 간단하고 탄력적인 플랫폼을 제공하는 Snowflake의 플랫폼에 대해 알아보고, SAP 데이터를 Snowflake로 오프로드할 때 누릴 수 있는 이점을 알아보세요.",
        imgSrcPd: "/img/salesforce/snowflake-product-02.png"
    },
    {
        title: "애플리케이션을 통한 영향력 확장",
        description: "Snowflake, https://www.snowflake.com/",
        description_01:
            "기존에 분석된 데이터 역량을 넘어, Streamlit in Snowflake를 활용해 몇 분 만에 인터랙티브 앱을 구축할 수 있도록 지원합니다. 고객 맞춤형 애널리틱스 애플리케이션을 통해 데이터 활용 가치를 극대화할 수 있습니다.",
        // description_02: "고유한 내부 애플리케이션을 만들어 IT 운영을 효율화하고 비용을 절감하고 싶으신가요? Streamlit을 사용해보세요.",
        imgSrcPd: "/img/salesforce/snowflake-product-03.png"
    },
    {
        title: "실시간 보안 가시성 제공",
        description: "Snowflake, https://www.snowflake.com/",
        description_01:
            "Snowflake의 보안 기능을 통해 실시간 보안 성과를 가시화하고 자동화된 통제 모니터링 체계를 구축합니다. 이를 통해 보안 운영의 신뢰성과 대응 효율을 동시에 확보하고 문제 해결을 자동화할 수 있습니다.",
        // description_02: "Snowflake의 IT 팀이 자산 인벤토리 데이터를 효과적으로 활용하여 보안 운영을 강화하는 방법을 자세히 알아보세요.",
        imgSrcPd: "/img/salesforce/snowflake-product-04.png"
    }
];

const FeatureSnowflake = () => {
    return (
        <>
            <BusinessTabs current="snowflake" />

            <FeatureSnowflakeHead />
            {/* <div className="container mx-auto max-w-6xl space-y-52 p-6 px-8 py-12 lg:max-w-7xl lg:px-12"></div> */}

            <Section id="1" bg="white" width="6xl" space="lg">
                    <p className="mx-auto max-w-6xl text-center text-h1 font-bold text-black">
                        비용 절감과
                    </p>
                    <h1 className="mx-auto mb-section max-w-6xl text-center text-h1 font-bold tracking-tight text-[#249EDC]">
                        데이터 중심 문화를 실현하는
                        <br className="hidden lg:block" />
                        &nbsp;Snowflake
                    </h1>
                    <div className="mx-auto grid max-w-6xl grid-cols-1 gap-section">
                        {ProductLists.map((list, index) => (
                            <div
                                key={list.imgSrcPd}
                                className={`flex flex-col items-center justify-between gap-8 sm:gap-12 lg:gap-20 ${
                                    index % 2 === 1
                                        ? "sm:flex-row-reverse"
                                        : "sm:flex-row"
                                }`}
                            >
                                <div className="w-full sm:w-[48%]">
                                    <h2 className="text-h2 font-bold">
                                        {list.title}
                                    </h2>
                                    <p className="mt-6 text-body font-normal">
                                        {list.description_01}
                                    </p>
                                </div>

                                <div className="w-full sm:w-[48%]">
                                    <img
                                        className="h-auto w-full rounded-lg object-contain"
                                        src={list.imgSrcPd}
                                        alt=""
                                    />
                                    <p
                                        className={`mt-2 text-left text-caption text-gray-400 ${
                                            index % 2 === 1
                                                ? "sm:text-left"
                                                : "sm:text-right"
                                        }`}
                                    >
                                        {list.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
            </Section>
        </>
    );
};

export default FeatureSnowflake;
